import { useMutation } from "@tanstack/react-query";

import { MediaApi } from "./media.api";

export namespace MediaQueries {
  export const useGetPresignedUrl = () => {
    return useMutation({
      mutationFn: MediaApi.getPresignedUrl,
    });
  };

  export const useUploadPut = () => {
    return useMutation({
      mutationFn: MediaApi.uploadPut,
    });
  };

  export const useUploadPost = () => {
    return useMutation({
      mutationFn: MediaApi.uploadPost,
    });
  };
}
